###
 * Map toolbar for truth strip drawing (part of Planting Rx). This borrows *heavily*
 * from the core DrawToolbar (which is oriented towards more detailed drawing tools,
 * like field and managemnet zone editing).
 *
 * Maybe at some point, a base class could be derived that would simplify both toolbar
 * classes.
 *
###


class exports.TruthStripToolbar extends L.Class
    constructor: () ->
        TruthStripToolbar.include(L.Mixin.Events)
        @drawMode       = ko.observable 'inactive'
        @currentTool    = ko.observable()

        @dontReenableDraw = false
        # Most recently clicked button (the currently active tool, usually)
        @lastClicked    = ko.observable()

        # Previously clicked button (which tool was active before the current, usually)
        @prevClicked    = ko.observable()
        @orig_options   = @initShapeDefaults()
        @drawnOptions   = @orig_options.shape


        # Set up the tools on the Truth Strip drawing bar
        @drawControlOptions =
            position: 'topleft'
            draw:
                style:
                    color: '#008161'
                    width: 3
                rectangle:
                    shapeOptions: @orig_options.shape
            finished:
                style:
                    'fillOpacity': 0.6,
                    'weight': 2,
                    'color': '#0F0'
            colors:
                style: (mode) =>
                    if @mode is 'add'
                        return {
                            color: '#008000'
                            width: 3
                        }
                    if @mode is 'subtract'
                        return {
                            color: '#FF0000'
                            width: 3
                        }
            toolbars: [
                { # Box/Group
                    rows: [
                        [
                            { name: 'draw-rect-add', html: '<i class="drawicon-rect-green"></i>', toggle: true },
                        ],
                    ]
                }
            ]

        @events         = new L.MassEvents()


    init: () ->
        # Initialize the draw control and pass it the FeatureGroup of editable layers
        @drawControl = new L.Control.MfDraw()
        @drawControl.options = @drawControlOptions

        if not @drawnItems?
            @initDrawnItems()
        else
            App.map.addLayer @drawnItems

        # add the control to the map
        App.map.addControl(@drawControl)

        @initListeners()



    # Little helper for getting the original default shape parameters for L.Draw handlers
    initShapeDefaults: () ->
        shapeOpts = {
            fillColor: '#0066FF'
            color: '#0033FF'
            opacity: 0.75
            weight: 2
            fillOpacity: 0.6
        }

        editOpts = $.extend shapeOpts, {
            color: '#0033FF'
            fillOpacity: 0.6
            guidelineDistance: 20
        }

        return { shape: shapeOpts, edit: editOpts }


    # Initializes primary listeners. These include handling the toggling of buttons/
    # disabling of the previous button's tool as well as more complex behaviors like
    # spawning L.Draw handlers when draw buttons are pressed. If a button is misbehaving,
    # it's most likely because something is borky here.
    initListeners: () ->
        self = this

        # Wire up union/difference handling when a new shape is drawn
        App.map.on 'draw:created', @handleDrawComplete

        # AAAALLLL the other things
        @drawControl.addCallback '*', @_anyButtonPressed
        #@drawControl.addCallback 'draw-select',@_selectPressed


    initDrawnItems: () ->
        @drawnItems = new L.FeatureGroup()
        App.map.addLayer @drawnItems


    startDrawStrip: () =>
        @_anyButtonPressed({}, 'draw-rect-add')

        @currentTool( new L.Draw.Rectangle App.map, @drawControl.options.draw.rectangle )
        @currentTool().enable()
        @drawMode 'draw'


    _anyButtonPressed: (e, name) =>
        @_setStyles()
        # handles cancelling existing edits
        if @currentTool()? and @currentTool().disable?
            @currentTool().disable()

        @prevClicked @lastClicked()
        @lastClicked name


    # Handles adding edit handles when you've selected
    # the 'select' tool
    # I guess we don't have a 'select' tool anymore
    #_selectPressed: () =>
    #    self = @
    #    @drawnItems.on 'click',@_polySelected
    #    @fire 'select:no-poly'

    #    @drawMode 'select'
    #    # This is kiind of hacky.. if the user clicks off
    #    # the tool without doing anything, we have to clean up
    #    @currentTool {
    #        h: null
    #        disable: () ->
    #            self.drawMode 'inactive'
    #            if @h? and @h.disable?
    #                @h.disable()
    #            self.drawnItems.off 'click',@_polySelected
    #    }


    handleDrawComplete: (e) =>
        self    = this
        type    = e.layerType
        layer   = e.layer

        L.GeoUtil.unnestAdd @drawnItems, layer
        @drawMode 'inactive'
        @_setStyles()
        @fire 'toolbar:shape-added'



    _polySelected: (e) =>
        @drawMode 'edit'
        handler = new L.Edit.PolyWithHoles(e.layer)
        handler.enable()
        @fire 'select:poly-selected'


        # Disable the previous selection
        if @currentTool().h? and @currentTool().h.disable?
            @currentTool().h.disable()

        #@currentTool#().disable()
        @currentTool().h = handler



    ###
     * activate: (name) -> null
     *     - name (string): name of the button to activate
     *
     * Allow you to programmatically activate a button by name
    ###
    activate: (name) =>
        btn = @drawControl.getButton(name)

        if btn?
            @drawControl.handleClick name



    # Sets styles for the whole drawnItems featuregroup
    _setStyles: (style) ->
        if not style?
            style = @drawnOptions

        @drawnItems.eachLayer (l) ->
            if l.setStyle?
                l.setStyle style


    # Cleans up the L.Control.MfDraw, disables any active tools,
    # and removes event listeners. Also removes the @drawnItems
    # feature group from the map
    destroy: () ->
        if @drawControl
            App.map.removeControl @drawControl
            @drawControl = null

        if @currentTool()? and @currentTool().disable?
            @currentTool().disable()

        App.map.off 'draw:created', @handleDrawComplete

        if @drawnItems
            App.map.removeLayer @drawnItems



    disableCurrent: () =>
        @currentTool()?.disable?()
        @currentTool(null)



    getAreas: (pusharray = [], start) ->
        if not start?
            start = @drawnItems

        return [] if not start

        start.eachLayer (layer) =>
            if layer instanceof L.FeatureGroup
                @getAreas pusharray, layer
            else
                pusharray.push layer

        return pusharray
